"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const model_interactions_1 = require("@completeanatomy/model-interactions");
const device_1 = require("@completeanatomy/device");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const lodash_1 = require("lodash");
function ModeTemplate({ mode, title, onBack = lodash_1.noop, children, detail = null, disableHideUI, shouldShowModelLoading = false, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const [isControlsHidden, setControlsHidden] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isModelLoading = (0, models_1.useIsModelLoading)();
    const onBackInternal = () => {
        navigate(-1);
        onBack();
    };
    const toggleControlsState = () => {
        setControlsHidden(prevState => !prevState);
    };
    const shouldShowSkeletonAnimation = shouldShowModelLoading && isModelLoading;
    return ((0, jsx_runtime_1.jsxs)(model_interactions_1.ModelInteractionsLayer, { "data-e2e": 'ModeTemplate_ModelInteractionsLayer', children: [(0, jsx_runtime_1.jsx)(ui_1.SkeletonOverlay, { animated: true, shown: shouldShowSkeletonAnimation, "data-e2e": 'ModeTemplate_SkeletonOverlay' }), isControlsHidden && ((0, jsx_runtime_1.jsx)(ShowControlsButton, { onClick: toggleControlsState, "data-e2e": 'ModeTemplate_ShowControlsButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Fullscreen_Exit, width: 20, height: 20, "data-e2e": 'ModeTemplate_Icon' }) })), !isControlsHidden && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ui_1.Header, { type: ui_1.HeaderType.WithBackButton, backButton: {
                            label: (0, i18n_1.Localized)(i18n_1.Strings.header.back),
                            onClick: onBackInternal,
                        }, subheader: isMobile ? title : undefined, withSubheaderInitialAnimation: isMobile, "data-e2e": 'ModeTemplate_Header', children: [(0, jsx_runtime_1.jsx)(ui_1.ContentTitle, { title: mode, subtitle: !isMobile ? title : undefined, "data-e2e": 'ModeTemplate_ContentTitle' }), !disableHideUI && ((0, jsx_runtime_1.jsx)(ui_1.Header.Right, { children: (0, jsx_runtime_1.jsx)(HideControlsButton, { onClick: toggleControlsState, "aria-pressed": !isControlsHidden, "data-e2e": 'ModeTemplate_HideControlsButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Fullscreen_Enter, width: 20, height: 20, "data-e2e": 'ModeTemplate_Icon' }) }) }))] }), !shouldShowSkeletonAnimation && ((0, jsx_runtime_1.jsxs)(ContentContainer, { "$isMobile": isMobile, "data-e2e": 'ModeTemplate_ContentContainer', children: [detail, (0, jsx_runtime_1.jsx)(Content, { "$isMobile": isMobile, "data-e2e": 'ModeTemplate_Content', children: children })] }))] }))] }));
}
exports.ModeTemplate = ModeTemplate;
const ContentContainer = styled_components_1.default.div `
  width: ${({ theme }) => theme.infoBoxWidth}px;
  height: ${({ $isMobile }) => ($isMobile ? 'initial' : '100%')};

  background-color: ${({ theme }) => theme.backgroundWithOpacity};

  ${({ $isMobile }) => $isMobile &&
    (0, styled_components_1.css) `
      position: absolute;
      bottom: 0;

      width: 100%;
      height: initial;
    `}
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  width: ${({ theme }) => theme.infoBoxWidth}px;
  height: calc(100% - ${({ theme }) => theme.headerHeight}px);
  padding: 8px;

  ${({ $isMobile, theme }) => $isMobile &&
    (0, styled_components_1.css) `
      width: 100%;

      background-color: ${theme.backgroundSecondary};
    `}
`;
const HideControlsButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  padding: 0;
`;
const ShowControlsButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  position: absolute;
  top: calc(6px + env(safe-area-inset-top));
  top: calc(6px + constant(safe-area-inset-top));
  right: 6px;

  width: 27px;
  height: 27px;

  margin: 0;
  padding: 0px;

  border-radius: 1px;
`;
